import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { LabeledInfo } from 'ui-components/components/labeled-info-list/labeled-info';
import getCarrierDisplayName from '../../../../../components/data-driven-logo/get-carrier-display-name';

import messages from '../../messages';

const Carriers = ({ data: carrierIds }) => {
  const intl = useIntl();
  return (
    <LabeledInfo label={intl.formatMessage(messages.carrier, { count: carrierIds.length })}>
      {carrierIds.map((carrierId) => (
        <span key={carrierId}>
          <FormattedMessage {...getCarrierDisplayName(carrierId)} />
        </span>
      ))}
    </LabeledInfo>
  );
};

Carriers.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Carriers;
